module.exports = __webpack_public_path__ + "assets/img/chrome.d2bf578a.svg";